import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import { useEffect, useState } from "react";
import { FaRegEye } from "react-icons/fa6";
import { HistoricInterface } from "../../common/interfaces";
import { extractErrorMessage } from "../../common/utils/axios.isAxiosError";
import CustomTooltip from "../../components/CustomTooltip";
import PaginationControls from "../../components/PaginationControls";
import { HistoricOccurrenceLabel } from "../../components/enum/historicOccurrenceEnum";
import {
  TableNameEnum,
  TableNameEnumLabel
} from "../../components/enum/tableNameEnum";
import HistoricModal from "../../components/modal/HistoricDetailsModal";
import { ToastError } from "../../components/toaster/toast.utils";
import api from "../../services/api";
import { TextFeldUserSearch } from "../users/Users.styles";
import {
  ActionButton,
  Container,
  ProductSearchCard,
  StatusCell,
  Table,
  TableContainer,
  Title
} from "./historic.styled";

export const Historic = () => {
  const [historics, setHistorics] = useState<HistoricInterface[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");

  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");

  const [tableName, setTableName] = useState<TableNameEnum>(TableNameEnum.NONE);

  // controle do modal de detalhes
  const [historicModalOpen, setHistoricModalOpen] = useState(false);
  const [selectedHistoricId, setSelectedHistoricId] = useState<
    number | undefined
  >(undefined);

  const fetchHistoric = async (currentPage: number) => {
    try {
      const response = await api.get("/historic", {
        params: {
          page: currentPage,
          limit: 8,
          search: search.trim() !== "" ? search.trim() : undefined,
          initial_date: startDate || undefined,
          final_date: endDate || undefined,
          department: tableName !== TableNameEnum.NONE ? tableName : undefined
        }
      });

      setHistorics(response.data.mappingItems);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      const msg = extractErrorMessage(error);
      console.error("Erro ao buscar histórico:", error);
      ToastError(msg);
    }
  };

  useEffect(() => {
    fetchHistoric(page);
  }, [page, search, startDate, endDate, tableName]);

  const openDetailDialog = (historic: HistoricInterface) => {
    setSelectedHistoricId(historic.historic_id);
    setHistoricModalOpen(true);
  };

  return (
    <Container>
      <Title>Histórico do Sistema</Title>

      <ProductSearchCard>
        <TextField
          label="Data de Início"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            max: new Date().toLocaleDateString("en-CA")
          }}
        />

        <TextField
          disabled={!startDate}
          label="Data Final"
          type="date"
          value={startDate ? endDate : ""}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            min: startDate || undefined,
            max: new Date().toLocaleDateString("en-CA")
          }}
        />

        <TextFeldUserSearch
          id="historic_search"
          label="Nome do Usuário"
          variant="outlined"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />

        <FormControl style={{ minWidth: 200 }}>
          <InputLabel id="label-status">Departamento</InputLabel>
          <Select
            labelId="label-status"
            value={tableName !== TableNameEnum.NONE ? tableName : ""}
            label="Departamento"
            onChange={(e) => setTableName(e.target.value as TableNameEnum)}
          >
            {(Object.values(TableNameEnum) as TableNameEnum[])
              // .filter(code => code !== TableNameEnum.NONE)
              .map((statusCode) => (
                <MenuItem key={statusCode} value={statusCode}>
                  {TableNameEnumLabel[statusCode]}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </ProductSearchCard>

      <TableContainer>
        <Table>
          <thead>
            <tr>
              <th>Data</th>
              <th>Usuário</th>
              <th>Empresa</th>
              <th>Departamento</th>
              <th>Ocorrência</th>

              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {historics.map((item) => {
              const dateObj = new Date(item.historic_date);
              const formattedDate = dateObj.toLocaleDateString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "2-digit"
              });
              const formattedTime = dateObj.toLocaleTimeString("pt-BR", {
                hour: "2-digit",
                minute: "2-digit"
              });

              return (
                <tr key={item.historic_id}>
                  <td>{`${formattedDate} ${formattedTime}`}</td>
                  <td>{item.user.user_name}</td>
                  <td>{item.company.company_name}</td>
                  {/* <td>{TableNameEnumLabel[item.historic_department]}</td> */}
                  <td>{TableNameEnumLabel[item.historic_department]}</td>
                  <StatusCell status={item.historic_occurrence}>
                    {HistoricOccurrenceLabel[item.historic_occurrence]}
                  </StatusCell>

                  <td>
                    <CustomTooltip title="Exibir Detalhes">
                      <ActionButton onClick={() => openDetailDialog(item)}>
                        <FaRegEye size={20} color="#004336" />
                      </ActionButton>
                    </CustomTooltip>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </TableContainer>

      <PaginationControls
        page={page}
        totalPages={totalPages}
        setPage={setPage}
      />

      <HistoricModal
        open={historicModalOpen}
        onClose={() => setHistoricModalOpen(false)}
        historic_id={selectedHistoricId}
      />
    </Container>
  );
};
